
(function ($, d, ns) {
    ns.initTeamToggle = function () {

        $('[data-team-listing-item-toggle]').on('click', function (e) {
            var parent = $(this).closest('[data-team-listing-item]');
            if (!parent.hasClass('active')) {
                //Close others.
                $('[data-team-listing-item].active').removeClass('active');
            }
            parent.toggleClass('active');

        });
    }

    $(d).ready(function () {
        ns.initTeamToggle();
    });

})(jQuery, document, Crafted.Utilities);